export const isProRoute = (pathname: string) => {
  const proRoutes = ["livestock", "reports", "medicine"] as const;

  return proRoutes.some((proRoute) => pathname.indexOf(proRoute) > -1);
};
